/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaNotificationBadge from 'DesignSystem/TysiaNotificationBadge/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/WorkflowsAction/Content/Status/Content"
  
}) {
let pendingExecutionsValueData = fromData.useDataFormat({ viewPath,
context: 'pending_executions',
format: fromFormat.listLength,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
  return (<React.Fragment
>
<TysiaNotificationBadge
  viewPath={`${viewPath}/TysiaNotificationBadge`}
 marginLeft={dtSpaceXxs}
 backgroundColor={dtColorsNeutral300}
 color={dtColorsNeutral900}
 fontSize={dtTypographyFontsizeMm}
 data="pending_executions"
 format="/Data/format.js listLength"
 text={pendingExecutionsValueData}
/>
{children}
</React.Fragment>)
}